// src/services/firebase.js
import { initializeApp } from "firebase/app";
import {
  initializeFirestore,
  persistentLocalCache,
  persistentSingleTabManager,
} from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// ⚠️ Mets tes propres clés si besoin
const firebaseConfig = {
  apiKey: "AIzaSyBA3O2eJug-nNV4n-1tmgkAduxw7XtjgUA",
  authDomain: "ghana-67644.firebaseapp.com",
  projectId: "ghana-67644",
  storageBucket: "ghana-67644.firebasestorage.app",
  messagingSenderId: "290403779751",
  appId: "1:290403779751:web:7acf15cde278efacdec782",
  measurementId: "G-VYD8S1T5SF",
};

const app = initializeApp(firebaseConfig);

// ✅ Active la persistance au moment de l'initialisation (aucun appel Firestore avant)
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentSingleTabManager(), // single-tab ; remplace par persistentMultipleTabManager() si tu veux multi-onglets
  }),
});

export const auth = getAuth(app);
export const storage = getStorage(app);

// Petit garde-fou pour HMR: éviter les doublons côté dev
if (typeof window !== "undefined") {
  // marquer qu’on a déjà initialisé Firestore (optionnel)
  window.__FIREBASE_DB_READY__ = true;
}
